import React from "react";
import { Link } from "react-router-dom";
import { RECENT_PLACEMENTS } from "../data/site";

export default function RecentPlacements() {
  if (!RECENT_PLACEMENTS?.length) return null;
  return (
    <section
      className="border-t border-[hsl(var(--rule))]"
      data-testid="recent-placements"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-16 items-start">
          <div className="md:col-span-4">
            <p className="label mb-3">Recently placed</p>
            <h2 className="serif text-3xl md:text-4xl tracking-tight leading-tight">
              Where the work{" "}
              <span className="italic text-[hsl(var(--ink-soft))]">
                is going.
              </span>
            </h2>
            <p className="mt-4 text-sm text-[hsl(var(--ink-soft))]">
              A quiet log of recent acquisitions. Collectors kept anonymous —
              only the city and month.
            </p>
          </div>
          <ul className="md:col-span-8 divide-y divide-border">
            {RECENT_PLACEMENTS.map((p) => (
              <li
                key={`${p.id}-${p.when}`}
                className="grid grid-cols-1 md:grid-cols-[1.6fr_2fr_1fr] gap-3 md:gap-6 py-4 md:py-5 items-baseline"
                data-testid={`placement-${p.id}`}
              >
                <Link
                  to={`/work/${p.slug}/${p.id}`}
                  className="serif italic text-xl md:text-2xl link-underline"
                >
                  {p.title}
                </Link>
                <p className="text-[hsl(var(--ink-soft))]">{p.detail}</p>
                <p className="label md:text-right">{p.when}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
